
const state = {
  currentVariantId: null,
  price: 0,
};

const mutations = {
  SELECT_VARIANT (state, variantId) {
    state.currentVariantId = variantId;
  },
  SET_PRICE (state, price) {
    state.price = price;
  },
};

const actions = {
  selectVariant ({ commit }, variantId) {
    commit('SELECT_VARIANT', variantId);
  },
  currentPrice ({ commit }, price) {
    commit('SET_PRICE', price);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
